import { VueQueryPlugin } from "@tanstack/vue-query";
import { createPinia } from "pinia";
import { createApp } from "vue";

import App from "@/app/App.vue";
import { bootstrapAuth } from "@/app/providers/auth";
import { queryClient } from "@/app/providers/query";
import { router } from "@/app/router";

import "@/app/styles/globals.css";

const app = createApp(App);
const pinia = createPinia();

app.use(pinia);

await bootstrapAuth();

app.use(router);
app.use(VueQueryPlugin, { queryClient });
app.mount("#app");
